import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';

const Modal = ({
  className,
  isShowing,
  hide,
  closeBackground,
  children,
  showCloseButton
}) =>
  isShowing
    ? ReactDOM.createPortal(
        <div className={className} data-testid="modal">
          <div className="modal">
            <div className="modal__overlay" />
            <div
              className="modal__wrapper"
              aria-modal
              aria-hidden
              tabIndex={-1}
              role="dialog"
              onClick={() => closeBackground && hide()}
              data-testid="modal__wrapper"
            >
              <div
                className="modal__container"
                data-testid="modal__container"
                onClick={e => e.stopPropagation()}
              >
                {showCloseButton && (
                  <button
                    type="button"
                    className="modal__close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={hide}
                  >
                    <Icon glyph="close-thin" size="1.6rem" />
                  </button>
                )}
                <div className="modal__body">{children}</div>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )
    : null;

Modal.defaultProps = {
  closeBackground: false,
  showCloseButton: true
};

Modal.propTypes = {
  className: PropTypes.string,
  isShowing: PropTypes.bool.isRequired,
  hide: PropTypes.func.isRequired,
  closeBackground: PropTypes.bool,
  showCloseButton: PropTypes.bool
};
export default Modal;
